export const Messages = {
  EMPTY_PERMISSIONS: 'Es necesario asignar al menos un permiso para crear un rol',
  ROLE_CREATE_SUCCESS: 'Rol creado exitosamente, puede administrarlo en la lista de roles',
  UPDATE_ROLE_SUCCESS: 'Rol actualizado exitosamente',
};
